var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCarRedmax(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1222,
    height: 501,
    viewBox: "0 0 1222 501",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M283.821 46.7549L283.517 50.6484",
    stroke: "#1B1B19",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M128.223 448.078C131.868 449.128 142.333 449.707 142.333 449.707L142.443 449.597L143.879 449.707C148.325 450.094 153.129 450.619 157.575 450.84C172.265 451.806 187.204 452.579 201.921 452.883C217.882 453.38 234.118 453.601 250.078 453.601C256.843 453.656 264.106 453.297 270.871 453.104C273.522 452.883 278.05 451.392 280.452 450.646L280.949 455.865C280.204 455.948 279.486 456.114 278.768 456.362C278.299 456.5 277.443 456.804 277.001 457.273C276.642 457.687 276.697 457.991 276.697 457.991C277.028 462.547 278.381 468.677 279.486 473.123C279.872 474.697 280.259 476.298 280.701 477.872C281.087 479.281 281.502 480.661 281.943 482.042C282.33 483.174 282.689 484.389 283.297 485.411C285.533 489.276 288.736 495.324 291.636 498.527C291.636 498.527 292.243 499.328 293.375 499.438L295.336 499.548C295.943 499.548 300.113 495.738 300.472 495.103C300.693 494.716 300.748 494.302 300.472 493.86H300.582L301.3 494.275H301.411L304.945 492.673C304.945 492.673 304.973 492.673 305 492.7C305.773 492.397 305.442 491.458 305.525 490.823C303.813 482.677 300.085 469.34 298.042 461.139C298.042 461.084 298.014 461.001 297.987 460.946L297.02 458.102C296.937 457.826 296.772 457.604 296.523 457.439L294.369 455.865C294.176 455.727 293.983 455.616 293.762 455.534L292.354 455.009C291.884 453.325 291.718 451.806 291.967 450.453H293.099L378.257 450.259C423.294 451.143 516.294 452.027 516.294 452.027C595.184 452.634 685.312 452.993 777.208 452.938L814.651 453.076C814.651 453.076 1056.59 451.613 1157.57 449.321C1159.73 449.266 1163.37 449.265 1163.37 449.265C1163.7 449.404 1163.93 449.68 1164.28 449.68C1172.76 448.907 1184.99 447.83 1193.08 445.51H1194.22C1194.22 445.51 1194.71 445.593 1195.05 444.792C1195.05 444.792 1198.03 443.853 1198.22 443.771C1198.22 443.771 1200.51 443.163 1201.09 442.445L1201.64 441.92L1201.92 441.644L1202.8 439.822C1202.8 439.822 1205.92 433.443 1207.53 425.049C1212 415.219 1214.4 403.345 1215.84 392.466C1215.98 391.389 1216.06 390.422 1216.14 389.539C1218.9 353.863 1221.17 287.868 1220.89 253.049C1220.89 252.469 1220.89 247.388 1220.89 246.394C1221.11 211.298 1218.88 146.352 1216.14 111.063C1216.09 110.18 1215.98 109.213 1215.84 108.136C1214.43 97.2567 1212 85.3833 1207.53 75.5531C1205.92 67.1588 1202.8 60.7803 1202.8 60.7803L1201.92 58.9578L1201.64 58.6817L1201.09 58.1569C1200.51 57.439 1198.22 56.8315 1198.22 56.8315C1198.03 56.7487 1195.05 55.8099 1195.05 55.8099C1194.74 55.0091 1194.22 55.0919 1194.22 55.0919H1193.08C1184.99 52.7724 1172.76 51.6955 1164.28 50.9224C1163.93 50.9224 1163.68 51.1709 1163.37 51.3366C1163.37 51.3366 1159.73 51.3366 1157.57 51.2813C1056.59 48.9895 814.651 47.526 814.651 47.526L777.208 47.6642C685.312 47.609 595.156 47.9678 516.294 48.5753C516.294 48.5753 423.294 49.459 378.257 50.3426L293.099 50.1491H291.967C291.718 48.7961 291.856 47.2776 292.354 45.5933L293.762 45.0684C293.983 44.9856 294.176 44.8752 294.369 44.7371L296.523 43.1633C296.744 42.9976 296.91 42.7768 297.02 42.5006L297.987 39.6564C297.987 39.6564 298.042 39.5182 298.042 39.463C300.085 31.2619 303.813 17.9249 305.525 9.77913C305.47 9.14404 305.801 8.20539 305 7.90165C305 7.90165 304.973 7.90167 304.945 7.92929L301.411 6.32752H301.3L300.582 6.74178H300.472C300.748 6.29998 300.665 5.88592 300.472 5.49934C300.113 4.83663 295.971 1.05371 295.336 1.05371L293.375 1.16393C292.215 1.27438 291.636 2.07537 291.636 2.07537C288.736 5.27846 285.533 11.3257 283.297 15.1915C282.689 16.2408 282.33 17.428 281.943 18.5602C281.502 19.9408 281.087 21.3491 280.701 22.7297C280.259 24.3037 279.872 25.8775 279.486 27.4791C278.409 31.9524 277.028 38.0547 276.697 42.6109C276.697 42.6109 276.642 42.9146 277.001 43.3288C277.443 43.7982 278.299 44.1022 278.768 44.2403C279.458 44.4888 280.204 44.6543 280.949 44.7371L280.48 49.9836C278.05 49.2105 273.522 47.7193 270.871 47.4984C264.106 47.2775 256.843 46.9463 250.078 47.0015C234.118 47.0015 217.882 47.2225 201.921 47.7195C187.204 47.9956 172.265 48.7964 157.575 49.7628C153.129 49.9837 148.325 50.5081 143.879 50.8947L142.443 51.0053L142.333 50.8947C142.333 50.8947 131.868 51.4748 128.223 52.5241M128.526 52.4136C124.688 52.7449 120.74 53.5734 117.012 54.5398C112.898 56.1966 106.022 58.875 101.99 60.7527L101.383 60.8629L86.2511 63.0997C70.4842 64.9774 53.9993 69.0642 42.0982 80.0817C35.0293 86.7916 29.562 95.3791 25.3372 104.077C18.931 116.558 13.298 130.227 10.012 143.812C10.012 143.812 9.48739 144.199 8.79707 146.546C6.83656 152.455 6.44999 164.439 5.8149 170.541C5.04174 181.034 3.99245 192.355 3.13645 202.876C1.39684 217.87 0.872193 233.94 1.06548 250.342C0.872193 266.772 1.42445 282.843 3.13645 297.809C3.99245 308.33 5.04174 319.623 5.8149 330.144C6.44999 336.246 6.86417 348.23 8.79707 354.139C9.515 356.514 10.012 356.873 10.012 356.873C13.3256 370.458 18.9586 384.154 25.3372 396.608C29.562 405.306 35.0569 413.893 42.0982 420.603C53.9993 431.621 70.4566 435.68 86.2511 437.585L101.383 439.822L101.99 439.932C106.022 441.782 112.898 444.461 117.012 446.145C120.74 447.139 124.688 447.968 128.526 448.271",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1182.62 100.131V100.545V100.959L1183.34 101.76L1184.8 109.298L1192.59 178.606L1195.18 248.301V248.356L1192.59 317.996L1184.8 387.305L1183.34 394.953",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1184.97 82.9268C1184.97 82.9268 1182.26 86.599 1183.7 92.6462L1185.66 100.571V101.538C1185.66 101.538 1189.19 119.376 1191.32 136.302C1191.32 136.302 1198.08 184.763 1197.59 246.919V248.355V254.347L1197.48 263.487L1197.06 281.684L1196.54 295.822L1195.93 309.131L1195.1 322.054L1194.16 334.452L1193.03 345.939L1192.01 355.604L1190.77 364.743L1189.52 373.497L1188.39 380.704L1187.15 387.607L1186.73 389.347L1186.43 391.169L1185.71 394.924",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1159.67 103.583L1168.04 176.674L1170.83 250.18L1168.04 323.685L1159.67 396.749",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1152.27 103.69L1160.61 176.699L1163.4 250.121V250.177L1160.61 323.544L1152.27 396.553",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1146.83 399.288L1155.59 325.645L1159.51 250.013L1155.59 174.409L1146.83 100.738",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M202.612 428.142C188.529 414.612 179.03 396.387 173.176 378.025C162.297 338.483 157.934 290.52 159.812 249.625C158.431 206.19 162.048 155.493 176.159 114.129C180.245 103.139 185.823 92.3972 192.92 83.0089C195.432 79.5297 199.077 75.7743 202.087 72.6264L203.026 71.8259L205.483 69.5891C205.566 69.451 205.594 69.3681 205.594 69.1748H205.483",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M168.814 390.755C151.031 346.657 150.368 292.702 150.368 250.261C150.368 207.82 151.003 153.892 168.814 109.767C170.167 107.005 173.48 99.9089 175.109 97.3685C176.462 94.4415 174.336 92.1218 171.161 93.3368C165.583 95.1868 155.228 97.3131 148.849 99.6326C144.928 101.068 143.769 102.256 141.532 104.99C134.187 116.891 127.781 141.798 126.538 149.198C120.822 178.854 120.602 212.707 120.905 250.261C120.602 287.814 120.822 321.64 126.538 351.324C127.781 358.752 134.187 383.631 141.532 395.532C143.796 398.266 144.956 399.453 148.849 400.889C155.228 403.208 165.583 405.335 171.161 407.185C174.336 408.4 176.462 406.08 175.109 403.153C173.48 400.613 170.167 393.516 168.814 390.755Z",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M152.853 250.261C152.826 207.71 152.715 134.011 181.433 88.9189L151.086 97.0649C147.275 98.1142 144.045 99.5222 141.311 101.98C140.262 102.919 139.406 104.079 138.798 105.349C118.006 146.934 118.171 199.122 118.171 250.261C118.171 301.4 117.978 353.588 138.798 395.173C139.433 396.443 140.262 397.603 141.311 398.542C144.045 400.999 147.248 402.408 151.086 403.457L181.433 411.603C152.715 366.511 152.826 292.84 152.853 250.261Z",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M5.34558 251.613C6.50532 266.33 9.59796 317.414 11.0062 326.996C13.6018 339.504 19.0416 352.565 28.2366 361.733V361.622L28.3471 361.512H28.4575C28.4575 361.512 28.7613 361.816 28.8717 361.926L29.1755 361.816C29.1755 361.816 29.3964 361.457 29.4792 361.402C29.7554 360.325 29.7001 358.806 29.5897 357.729C28.8717 351.074 26.8284 339.974 26.0828 333.319C23.2939 313.466 21.5819 292.563 20.8364 272.516C20.5603 267.297 19.7871 250.177 19.7871 250.177C19.7871 250.177 20.5326 233.057 20.8364 227.838C21.5819 207.819 23.3216 186.916 26.0828 167.035C26.8284 160.38 28.8441 149.307 29.5897 142.625C29.7001 141.548 29.7554 140.029 29.4792 138.952C29.3964 138.897 29.2307 138.621 29.1755 138.538L28.8717 138.428C28.8717 138.428 28.568 138.732 28.4575 138.842H28.3471L28.2366 138.731V138.621C19.0416 147.788 13.5742 160.849 11.0062 173.358C9.59796 182.94 6.53293 234.023 5.34558 248.741C5.26274 249.652 5.26274 250.563 5.34558 251.502V251.613Z",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M512.732 92.8398H488.626V100.82H512.732V92.8398Z",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M512.732 399.701H488.653V407.736H512.732V399.701Z",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M211.365 66.0547C211.338 66.1928 211.144 66.3309 211.172 66.4689C252.508 69.0369 295.253 73.9522 336.175 80.0822C336.12 80.7726 337.004 82.3189 337.197 83.5338C337.473 85.1078 335.954 87.3995 335.651 88.9182",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M220.201 201.359V201.663C220.008 202.022 219.594 202.353 219.262 202.574C218.324 202.74 213.298 203.568 212.359 203.679C211.669 203.927 210.84 203.623 210.509 202.961C210.426 202.436 210.399 201.663 210.399 201.138L212.028 173.387L216.087 145.885L222.548 118.824C222.631 118.466 222.907 117.83 223.266 117.609C224.288 117.278 227.519 116.974 228.623 116.808C228.954 116.753 229.369 116.891 229.645 117.002C229.728 117.112 229.811 117.388 229.838 117.499C224.26 144.863 221.72 173.498 220.174 201.359H220.201Z",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M110.523 59.6495C116.018 56.9158 122.48 54.5411 128.223 52.4425C131.868 51.3933 142.333 50.8135 142.333 50.8135L142.444 50.9237V51.255",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M101.99 60.6712C106.022 58.8211 112.898 56.1427 117.012 54.4583C120.74 53.4642 124.688 52.6358 128.526 52.332",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M345.812 74.3958C336.589 73.2913 277.912 66.4984 269.379 64.6484C267.336 64.1789 265.072 63.2402 263.194 62.3013L261.455 61.2797C261.206 61.1968 260.902 61.0865 260.626 61.0312",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M487.19 74.3958L498.207 74.3682V74.3958L498.511 74.5064L498.732 74.6995L498.843 74.893V79.587V74.893V89.9419L498.732 90.2456L498.511 90.5493H498.207L493.375 90.5769L487.3 90.4667",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M814.679 47.5L814.485 47.6935L814.375 47.9972L814.292 77.3773L813.768 78.8958L498.843 79.393L498.926 49.1018L498.622 48.6046",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M346.558 74.3955C378.893 74.9202 454.138 74.4507 487.218 74.3955L487.328 90.4664C458.031 90.2455 428.402 89.5273 399.16 87.8153C388.695 87.0698 377.926 86.2692 367.461 85.2751C358.183 84.2811 346.834 82.6242 337.611 80.995C337.611 80.857 337.611 80.5257 337.611 80.3876C339.848 77.9853 342.83 75.7485 345.84 74.3955H346.558Z",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0579 83.2309C89.0398 83.3689 171.851 75.8303 190.379 75.002",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3269 110.071C61.8139 103.665 75.5098 100.158 88.1841 96.9552C116.46 90.1072 156.913 83.2591 185.519 77.5432C188.364 76.632 190.793 74.4783 193.444 73.1805C197.117 71.1924 201.369 69.8668 205.484 69.2041",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M28.209 138.734V138.236L28.9269 133.46C28.9269 133.46 29.1202 132.742 29.4516 131.886",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6263 82.3191C56.374 85.2461 52.3701 89.029 48.7528 93.0053C48.4214 93.3918 48.0901 93.8062 47.7311 94.2204C45.2736 97.1474 43.3407 100.019 41.7944 103.084C37.4039 112.169 32.9582 122.524 29.4514 131.94C31.4948 129.04 34.1456 126.279 36.5479 123.711C41.2421 118.547 47.952 113.163 52.2872 107.751C62.3383 95.9325 70.8155 81.9048 83.7383 72.9307C75.7582 75.2778 67.7228 78.0115 60.6263 82.3467V82.3191Z",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M83.738 72.9037C83.738 72.9037 83.8209 72.9037 83.8761 72.8761L84.0694 72.6826C84.0694 72.6826 83.8485 72.8482 83.738 72.931V72.9037Z",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0974 72.6557C89.2886 69.425 95.253 67.5474 101.19 66.1391C134.187 61.7211 227.16 56.8335 259.329 56.7783L261.482 61.2516L256.843 60.7547C235.002 58.9875 225.144 57.6067 205.511 69.1765",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M123.197 58.3515C129.769 55.5903 137.059 52.829 143.879 50.8133C148.325 50.4267 153.129 49.902 157.575 49.6811C172.265 48.7146 187.204 47.9415 201.921 47.6377C217.882 47.1407 234.118 46.9198 250.078 46.9198C256.843 46.8645 264.105 47.2233 270.871 47.4166C273.936 47.6927 277.442 48.963 280.48 49.9018",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M1.03819 250.261C0.844902 233.831 1.39716 217.76 3.10916 202.794C3.96515 192.273 5.01445 180.98 5.78761 170.459C6.4227 164.357 6.8369 152.373 8.7698 146.464C9.48773 144.089 9.98475 143.73 9.98475 143.73C13.2983 130.144 18.9313 116.448 25.3099 103.995C29.5347 95.2969 35.0296 86.7095 42.0709 79.9996C53.972 68.982 70.4293 64.9229 86.2238 63.0176L101.356 60.7811L120.077 58.5443L202.695 54.071L204.766 53.9605L259.605 52.6351L275.151 54.2645L272.583 54.5682L274.599 60.4774C274.737 60.8916 275.123 61.1951 275.565 61.2227C285.727 62.0511 297.821 63.211 307.927 64.1498C308.148 64.1498 308.259 63.9012 308.093 63.7632L299.009 55.0651L296.33 54.5682C291.829 53.1047 291.139 49.7083 292.326 45.5664",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M293.596 447.444C347.469 447.085 445.743 447.003 463.581 446.699C465.128 446.699 466.646 446.423 468.11 445.926C471.893 444.6 475.482 442.447 477.498 438.94C478.547 437.09 479.431 434.881 479.403 432.727C479.072 431.208 477.167 430.628 475.814 430.38C472.997 429.634 469.766 429.579 466.867 429.358C442.292 429.11 400.431 429.469 375.91 429.358C361.441 429.11 346.033 430.518 331.675 432.506C307.237 435.295 281.392 438.029 256.871 439.713C257.175 440.541 257.313 442.281 258.611 441.646C259.936 443.358 258.721 445.926 259.439 447.748L259.633 447.859C262.256 447.748 269.049 447.638 278.161 447.555",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M275.151 54.2656C276.228 55.3701 276.78 56.3088 278.022 56.5021L298.456 57.7172L296.33 54.5693",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M275.151 54.2652C276.973 53.8786 278.796 52.7188 279.872 51.421L280.287 50.703C280.866 48.8254 280.949 46.6991 280.894 44.7109",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M297.959 39.6308C297.959 39.6308 298.014 39.4928 298.014 39.4376C300.058 31.2366 303.785 17.8996 305.497 9.7538C305.442 9.1187 305.774 8.17972 304.973 7.87598C299.533 10.582 298.649 18.0376 296.937 23.4773C295.667 28.4752 292.851 39.5202 291.801 44.3248C291.801 44.7666 291.387 45.7057 292.105 45.6505L293.734 45.0704C293.955 44.9876 294.149 44.8771 294.342 44.7391L296.496 43.1653C296.717 42.9996 296.882 42.7787 296.993 42.5026L297.959 39.6584V39.6308Z",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M291.911 45.6221C288.515 46.4229 284.594 45.4562 281.281 44.7383",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M300.472 6.68807C300.748 6.24627 300.665 5.83221 300.472 5.44563C300.113 4.78292 295.971 1 295.336 1L293.375 1.11056C292.215 1.22101 291.635 2.02166 291.635 2.02166C288.736 5.22475 285.533 11.272 283.296 15.1378C282.689 16.1871 282.33 17.3743 281.943 18.5065C281.502 19.8871 281.087 21.2954 280.701 22.676C280.259 24.25 279.872 25.8238 279.486 27.4254C278.409 31.8986 277.028 38.001 276.697 42.5571C276.697 42.5571 276.642 42.8609 277.001 43.2751C277.442 43.7445 278.298 44.0485 278.768 44.1866C281.253 45.0702 284.18 44.9871 286.168 43.2751C287.494 42.5296 287.963 38.5811 288.432 37.2833C290.697 29.5241 292.961 18.0372 296.164 11.0511C296.164 11.0511 296.716 10.0847 296.992 9.67048C297.765 8.53835 299.836 6.16343 300.472 6.68807Z",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M275.151 446.257C276.228 445.153 276.78 444.214 278.022 444.02L298.456 442.806L296.33 445.954",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M275.151 446.258C276.973 446.644 278.796 447.804 279.872 449.102L280.287 449.82C280.866 451.698 280.949 453.824 280.894 455.812",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M297.959 460.892C297.959 460.892 298.014 461.03 298.014 461.085C300.058 469.286 303.785 482.623 305.497 490.769C305.442 491.404 305.774 492.343 304.973 492.647C299.533 489.941 298.649 482.485 296.937 477.046C295.667 472.048 292.851 461.002 291.801 456.198C291.801 455.756 291.387 454.817 292.105 454.872L293.734 455.452C293.955 455.535 294.149 455.645 294.342 455.784L296.496 457.358C296.717 457.523 296.882 457.744 296.993 458.02L297.959 460.865V460.892Z",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M275.151 446.257L272.583 445.954L274.599 440.044C274.737 439.63 275.123 439.326 275.565 439.299C285.726 438.47 297.821 437.311 307.927 436.372C308.148 436.372 308.259 436.62 308.093 436.758L299.008 445.456L296.33 445.954C291.829 447.417 291.139 450.814 292.326 454.955",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M291.911 454.9C288.515 454.099 284.594 455.065 281.281 455.783",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M300.472 493.833C300.748 494.275 300.665 494.689 300.472 495.076C300.113 495.739 295.971 499.522 295.336 499.522L293.375 499.411C292.215 499.301 291.635 498.5 291.635 498.5C288.736 495.297 285.533 489.25 283.296 485.384C282.689 484.335 282.33 483.147 281.943 482.015C281.502 480.634 281.087 479.226 280.701 477.846C280.259 476.272 279.872 474.698 279.486 473.096C278.409 468.623 277.028 462.521 276.697 457.964C276.697 457.964 276.642 457.661 277.001 457.246C277.442 456.777 278.298 456.473 278.768 456.335C281.253 455.452 284.18 455.534 286.168 457.246C287.494 457.992 287.963 461.941 288.432 463.239C290.697 470.998 292.961 482.485 296.164 489.471C296.164 489.471 296.716 490.437 296.992 490.851C297.765 491.984 299.836 494.358 300.472 493.833Z",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M282.026 81.7409C282.026 81.7409 283.904 88.6718 273.715 88.0367C273.715 88.0367 261.068 87.7052 247.979 85.1096C247.979 85.1096 231.826 81.9619 214.043 77.3506C214.043 77.3506 205.953 92.2061 201.286 106.482C201.286 106.482 201.093 106.869 201.507 107.062L202.28 107.255C202.28 107.255 193.969 130.367 189.716 170.765C189.716 170.765 185.243 207.932 185.602 250.29",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M212.276 80.6348H208.052C208.052 80.6348 201.148 95.4904 198.332 104.741C198.332 104.741 191.456 114.24 190.241 119.348C190.186 119.624 190.158 119.9 190.158 120.177L190.103 131.995L184.884 161.375L185.989 162.176L184.222 174.546C184.222 174.546 183.228 175.181 183.117 176.037C183.117 176.037 180.19 209.973 179.859 220.163L179.389 232.782C179.389 232.782 179.748 233.803 180.356 234.19V242.777",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M173.701 250.26C173.977 119.541 204.047 75.6367 204.047 75.6367L205.483 75.3604H206.118C257.147 77.6246 337.086 89.0289 337.086 89.0289",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M179.251 250.262V244.436L180.052 243.856L180.604 243.718V250.262H179.251Z",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M179.251 244.436L179.693 243.525L180.411 242.807L180.77 243.331L180.135 243.69L179.251 244.436Z",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M257.754 203.898C261.869 203.484 277.249 202.849 279.458 203.373C281.17 204.285 284.484 211.878 285.257 213.424C285.257 213.452 285.312 213.618 285.312 213.645C285.312 214.032 285.229 214.418 284.898 214.639C284.318 215.053 266.121 215.274 262.669 214.75C262.007 214.75 258.113 206.631 257.423 205.61C257.285 205.334 257.064 204.919 257.119 204.588C257.119 204.588 257.064 203.981 257.727 203.87L257.754 203.898Z",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M223.293 203.981C223.293 203.981 262.062 200.225 278.133 200.115C286.555 200.005 295.142 199.866 303.454 201.137C306.657 205.306 309.777 210.332 311.572 215.274C311.572 215.274 312.621 218.257 312.704 218.643L312.676 218.615C312.842 219.168 311.931 218.864 311.931 218.864C307.457 217.097 243.782 218.726 222.465 218.202C222.465 218.202 222.714 208.565 223.293 203.981ZM223.293 203.981C223.183 204.809 223.183 203.981 223.183 203.981H223.293Z",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M289.647 202.574C292.823 202.629 296.385 202.685 299.533 203.099C299.533 203.099 300.085 203.154 300.775 204.12C301.687 205.446 303.04 207.351 303.757 208.787C304.89 210.692 306.077 213.067 306.629 215.193C306.684 215.414 306.519 215.387 306.519 215.387C303.426 215.221 300.03 215.221 296.909 215.111C296.606 215.111 296.302 214.972 296.109 214.752C295.418 213.951 294.894 212.239 294.48 211.548C293.154 208.732 290.669 205.639 289.04 203.016C289.04 203.016 288.681 202.519 289.647 202.602V202.574Z",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M303.344 200.558C302.184 171.233 298.87 113.08 296.855 83.6445",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M253.751 86.1849C253.475 96.2912 245.246 174.436 247.566 182.443C248.532 189.264 252.26 195.753 257.534 200.226C258.777 200.171 260.516 199.978 261.759 199.812C256.485 195.394 252.481 189.236 251.376 182.416C249.057 174.629 256.43 96.3741 256.623 86.6544L253.751 86.1572V86.1849Z",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M218.241 219.058L273.798 219.002H290.283L294.811 218.975C294.811 218.975 298.373 232.45 298.373 250.288",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M303.482 201.166L304.503 201.332C304.503 201.332 311.627 209.505 314.195 219.363L312.953 220.053L312.787 219.584C312.787 219.584 301.3 218.093 296.799 218.838C296.799 218.838 300.251 235.13 300.251 250.234",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M297.904 225.272L298.401 224.058C298.401 224.058 306.546 224.195 308.203 224.499L308.755 225.521V226.211C308.755 226.211 310.799 235.683 310.799 250.29",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M301.245 250.261L300.362 231.733C300.362 231.733 300.362 231.153 300.997 231.153H307.596C307.596 231.153 308.452 230.849 308.535 232.782C308.535 232.782 309.584 239.548 309.584 250.261",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M315.383 250.261C315.383 136.275 338.384 93.806 338.384 93.806C337.307 92.95 338.301 91.7627 338.301 91.7627C339.019 89.9126 337.666 89.3051 337.666 89.3051C337.004 89.3327 337.031 88.6148 337.031 88.6148L338.412 84.666L342.361 85.2738C342.361 85.2738 345.978 86.0192 343.493 90.0507L342.471 92.8673C342.471 92.8673 319 130.559 319 250.261",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M337.998 89.582L343.493 90.0239",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M338.439 90.4941L343.133 90.9081",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M343.106 90.8244C343.106 90.8244 345.426 90.9623 346.088 84.8047C346.088 84.8047 346.144 83.866 347.938 84.2526C347.938 84.2526 368.897 89.1952 412.056 90.0512L488.598 92.8401",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M342.333 92.8965L367.792 96.2375L488.626 100.821",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M211.365 434.467C211.338 434.329 211.144 434.191 211.172 434.053C252.508 431.485 295.253 426.57 336.175 420.44C336.12 419.75 337.004 418.203 337.197 416.988C337.473 415.414 335.954 413.122 335.651 411.604",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M220.201 299.162V298.859C220.008 298.5 219.594 298.169 219.262 297.948C218.324 297.782 213.298 296.954 212.359 296.843C211.669 296.595 210.84 296.898 210.509 297.561C210.426 298.086 210.399 298.859 210.399 299.383L212.028 327.134L216.087 354.637L222.548 381.697C222.631 382.056 222.907 382.691 223.266 382.912C224.288 383.243 227.519 383.547 228.623 383.713C228.954 383.768 229.369 383.63 229.645 383.52C229.728 383.409 229.811 383.133 229.838 383.023C224.26 355.658 221.72 327.024 220.174 299.162H220.201Z",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M110.523 440.872C116.018 443.606 122.48 445.981 128.223 448.079C131.868 449.129 142.333 449.708 142.333 449.708L142.444 449.598V449.266",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M101.99 439.851C106.022 441.701 112.898 444.379 117.012 446.063C120.74 447.058 124.688 447.886 128.526 448.19",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M345.812 426.127C336.589 427.231 277.912 434.024 269.379 435.874C267.336 436.344 265.072 437.283 263.194 438.221L261.455 439.243C261.206 439.326 260.902 439.436 260.626 439.491",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M256.843 439.74C235.002 441.508 225.144 442.888 205.511 431.318",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M487.19 426.128L498.207 426.156V426.128L498.511 426.018L498.732 425.824L498.843 425.631V420.937V425.631V410.582L498.732 410.278L498.511 409.975H498.207H493.375L487.3 410.058",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M814.679 453.024L814.485 452.83L814.375 452.527L814.292 423.147L813.768 421.628L498.843 421.131L498.926 451.422L498.622 451.919",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M346.558 426.126C378.893 425.602 454.138 426.071 487.218 426.126L487.328 410.056C458.031 410.277 428.402 410.994 399.16 412.706C388.695 413.452 377.926 414.253 367.461 415.247C358.183 416.241 346.834 417.898 337.611 419.527C337.611 419.665 337.611 419.996 337.611 420.134C339.848 422.537 342.83 424.773 345.84 426.126H346.558Z",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0579 417.293C89.0398 417.155 171.851 424.693 190.379 425.521",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3269 390.452C61.8139 396.858 75.5098 400.365 88.1841 403.568C116.46 410.416 156.913 417.264 185.519 422.98C188.364 423.891 190.793 426.045 193.444 427.343C197.117 429.331 201.369 430.656 205.484 431.319",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M28.209 361.79V362.287L28.9269 367.064C28.9269 367.064 29.1202 367.782 29.4516 368.638",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6263 418.203C56.374 415.276 52.3701 411.493 48.7528 407.517C48.4214 407.13 48.0901 406.716 47.7311 406.302C45.2736 403.375 43.3407 400.503 41.7944 397.438C37.4039 388.354 32.9582 377.999 29.4514 368.583C31.4948 371.482 34.1456 374.244 36.5479 376.812C41.2421 381.975 47.952 387.36 52.2872 392.772C62.3383 404.59 70.8155 418.617 83.7383 427.592C75.7582 425.245 67.7228 422.511 60.6263 418.176V418.203Z",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M83.738 427.619C83.738 427.619 83.8209 427.619 83.8761 427.647L84.0694 427.84C84.0694 427.84 83.8485 427.675 83.738 427.592V427.619Z",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0974 427.867C89.2886 431.098 95.253 432.976 101.19 434.384C134.187 438.802 227.16 443.689 259.329 443.745",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M123.197 442.169C129.769 444.93 137.059 447.691 143.879 449.707C148.325 450.094 153.129 450.619 157.575 450.839C172.265 451.806 187.204 452.579 201.921 452.883C217.882 453.38 234.118 453.601 250.078 453.601C256.843 453.656 264.105 453.297 270.871 453.104C274.35 452.8 277.111 451.557 280.452 450.618",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M259.605 447.885L204.766 446.559L202.695 446.449L120.077 441.976L101.355 439.739L86.2235 437.502C70.4566 435.625 53.9717 431.538 42.0706 420.52C35.0017 413.81 29.5344 405.223 25.3096 396.525C18.9034 384.044 13.2704 370.376 9.98445 356.79C9.98445 356.79 9.45982 356.403 8.7695 354.056C6.80899 348.147 6.42241 336.163 5.78731 330.061C5.01415 319.568 3.96486 308.247 3.10886 297.726C1.36925 282.732 0.844605 266.662 1.03789 250.26",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M282.026 418.782C282.026 418.782 283.904 411.851 273.715 412.487C273.715 412.487 261.068 412.818 247.979 415.413C247.979 415.413 231.826 418.561 214.043 423.173C214.043 423.173 205.953 408.317 201.286 394.041C201.286 394.041 201.093 393.655 201.507 393.461L202.28 393.268C202.28 393.268 193.969 370.156 189.716 329.758C189.716 329.758 185.243 292.592 185.602 250.233",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M212.276 419.889H208.052C208.052 419.889 201.148 405.033 198.332 395.783C198.332 395.783 191.456 386.284 190.241 381.175C190.186 380.899 190.158 380.623 190.158 380.347L190.103 368.529L184.884 339.149L185.989 338.348L184.222 325.977C184.222 325.977 183.228 325.342 183.117 324.486C183.117 324.486 180.19 290.55 179.859 280.361L179.389 267.742C179.389 267.742 179.748 266.72 180.356 266.334V257.746",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M173.701 250.26C173.977 380.979 204.047 424.883 204.047 424.883L205.483 425.159H206.118C257.147 422.895 337.086 411.491 337.086 411.491",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M179.251 250.26V256.086L180.052 256.666L180.604 256.804V250.26H179.251Z",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M179.251 256.087L179.693 256.998L180.411 257.716L180.77 257.191L180.135 256.833L179.251 256.087Z",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M257.754 296.623C261.869 297.037 277.249 297.672 279.458 297.148C281.17 296.237 284.484 288.643 285.257 287.097C285.257 287.069 285.312 286.903 285.312 286.876C285.312 286.489 285.229 286.103 284.898 285.882C284.318 285.468 266.121 285.247 262.669 285.771C262.007 285.771 258.113 293.889 257.423 294.911C257.285 295.187 257.064 295.601 257.119 295.933C257.119 295.933 257.064 296.54 257.727 296.651L257.754 296.623Z",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M223.293 296.539C223.293 296.539 262.062 300.294 278.133 300.405C286.555 300.515 295.142 300.653 303.454 299.383C306.657 295.213 309.777 290.188 311.572 285.245C311.572 285.245 312.621 282.263 312.704 281.876L312.676 281.904C312.842 281.352 311.931 281.656 311.931 281.656C307.457 283.423 243.782 281.794 222.465 282.318C222.465 282.318 222.714 291.955 223.293 296.539ZM223.293 296.539C223.183 295.711 223.183 296.539 223.183 296.539H223.293Z",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M289.647 297.948C292.823 297.893 296.385 297.838 299.533 297.423C299.533 297.423 300.085 297.368 300.775 296.402C301.687 295.076 303.04 293.171 303.757 291.735C304.89 289.83 306.077 287.455 306.629 285.329C306.684 285.108 306.519 285.136 306.519 285.136C303.426 285.302 300.03 285.301 296.909 285.412C296.606 285.412 296.302 285.55 296.109 285.771C295.418 286.572 294.894 288.284 294.48 288.974C293.154 291.791 290.669 294.883 289.04 297.506C289.04 297.506 288.681 298.003 289.647 297.921V297.948Z",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M303.344 299.963C302.184 329.288 298.87 387.44 296.855 416.876",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M253.751 414.336C253.475 404.23 245.246 326.085 247.566 318.077C248.532 311.257 252.26 304.768 257.534 300.295C258.777 300.35 260.516 300.544 261.759 300.709C256.485 305.127 252.481 311.285 251.376 318.105C249.057 325.892 256.43 404.147 256.623 413.867L253.751 414.363V414.336Z",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M218.241 281.463L273.798 281.519H290.283L294.811 281.546C294.811 281.546 298.373 268.071 298.373 250.233",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M303.482 299.358L304.503 299.192C304.503 299.192 311.627 291.019 314.195 281.161L312.953 280.471L312.787 280.94C312.787 280.94 301.3 282.431 296.799 281.686C296.799 281.686 300.251 265.394 300.251 250.29",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M297.904 275.25L298.401 276.466C298.401 276.466 306.546 276.327 308.203 276.024L308.755 275.002V274.312C308.755 274.312 310.799 264.841 310.799 250.233",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M301.245 250.26L300.362 268.788C300.362 268.788 300.362 269.368 300.997 269.368H307.596C307.596 269.368 308.452 269.671 308.535 267.739C308.535 267.739 309.584 260.974 309.584 250.26",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M315.383 250.26C315.383 364.246 338.384 406.714 338.384 406.714C337.307 407.57 338.301 408.758 338.301 408.758C339.019 410.608 337.666 411.215 337.666 411.215C337.004 411.187 337.031 411.905 337.031 411.905L338.412 415.854L342.361 415.247C342.361 415.247 345.978 414.501 343.493 410.47L342.471 407.653C342.471 407.653 319 369.962 319 250.26",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M337.998 410.94L343.493 410.498",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M338.439 410.03L343.133 409.644",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M343.106 409.698C343.106 409.698 345.426 409.56 346.088 415.718C346.088 415.718 346.144 416.657 347.938 416.27C347.938 416.27 368.897 411.328 412.056 410.472L488.598 407.683",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M342.333 407.626L367.792 404.285L488.626 399.701",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M490.089 395.367V399.813",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M375.578 299.41L376.103 299.907L376.213 300.018C382.923 307.418 388.501 311.891 397.558 315.26C398.221 315.508 399.657 315.868 399.657 315.868C402.556 316.917 406.146 317.635 409.238 318.021C423.21 318.767 451.652 319.733 465.403 320.23",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M377.622 298.499C380.687 301.757 383.945 305.458 387.728 307.943C387.894 308.053 388.032 308.164 388.032 308.164C395.404 313.023 404.185 315.923 413.049 316.282C413.27 316.282 413.574 316.309 413.684 316.309C428.954 316.861 445.577 317.386 460.874 318.021",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M381.156 302.201C381.736 301.704 384.884 300.793 385.464 300.765C387.369 300.406 392.146 300.158 392.146 300.158C402.777 299.854 413.85 301.704 424.232 303.831C428.926 304.852 434.338 306.481 439.06 307.282C442.291 307.586 445.632 308.193 448.918 308.276C449.111 308.276 449.249 308.276 449.249 308.276C450.796 308.359 452.452 308.414 453.999 308.386",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M379.168 303.167C375.634 304.989 373.839 307.917 373.093 309.159C370.995 312.335 369.31 325.23 368.454 328.985L367.018 341.08L366.411 347.182L365.997 353.174C365.665 359.967 365.583 364.026 367.488 376.562V376.507C369.2 382.057 371.354 386.392 376.849 388.657",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M452.95 305.21C450.078 305.099 447.151 304.657 444.307 304.298C432.627 301.924 418.986 298.113 407.168 296.677C399.74 296.015 390.545 295.904 383.089 296.926C382.923 296.926 380.687 297.478 379.803 297.81C378.091 298.417 376.158 299.08 374.75 299.936C373.121 300.902 370.939 302.89 370.939 302.89C366.494 307.032 365.583 314.156 364.561 319.872L363.125 327.604L361.882 335.335C361.579 337.903 360.806 344.53 360.557 347.015L360.143 354.858C360.088 364.55 361.358 374.766 365.196 383.713C366.687 387.027 369.145 389.981 372.403 391.748C372.403 391.748 373.121 392.163 373.922 392.604C374.143 392.715 374.363 392.825 374.584 392.908C376.103 393.46 377.705 394.123 379.334 394.537C387.783 396.581 400.817 397.023 410.868 395.946C421.554 395.007 434.145 392.08 444.97 391.527L446.985 391.472H450.851",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M452.204 388.489C446.847 387.771 441.766 388.02 436.409 388.323C429.258 388.986 421.499 390.836 414.209 391.444C414.209 391.444 412.69 391.609 412.11 391.665C404.848 392.355 397.199 392.548 390.02 391.996C386.347 391.554 382.482 391.333 379.113 389.759",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M482.771 307.751C482.578 308.911 482.026 313.909 481.833 315.179C481.556 316.532 481.418 317.029 480.866 317.554C480.341 318.051 479.679 318.354 478.961 318.465C474.211 319.155 468.275 319.183 463.525 319.349C461.675 319.266 460.377 317.581 459.3 316.505C456.235 313.163 453.971 309.491 452.922 305.211",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M479.679 391.806C479.486 390.646 478.934 385.648 478.74 384.378C478.464 383.025 478.326 382.528 477.774 382.003C477.249 381.506 476.586 381.202 475.869 381.092C471.119 380.401 465.182 380.374 460.433 380.208C458.583 380.291 457.285 381.975 456.208 383.052C453.143 386.393 450.879 390.066 449.83 394.346",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M481.336 320.01L480.728 349.914L479.292 379.709",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M479.292 379.709C478.74 379.433 464.354 378.273 463.332 378.19",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M466.535 319.319L465.403 320.23",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M463.221 380.399L464.354 350.218L465.403 320.23",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M395.322 377.362L396.343 349.114L396.454 346.27L397.586 315.261",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M441.325 376.561L442.346 347.982L443.479 319.43",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M463.36 377.361C447.537 377.03 420.283 375.291 404.351 375.567C400.678 376.036 398.497 376.45 394.631 377.472C393.057 378.079 391.345 378.521 389.799 379.184C388.805 379.847 387.645 380.426 386.596 381.006C382.04 384.209 377.069 387.992 373.535 392.3",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M375.468 393.129C384.552 384.873 386.43 381.228 399.132 378.495C402.114 377.915 405.124 377.445 408.189 377.362C424.453 377.887 442.401 378.715 458.721 379.185L460.681 379.295L463.277 379.406",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M465.403 321.501L468.44 321.336C468.44 321.336 481.197 320.397 481.308 320.01C481.308 320.01 483.379 318.464 483.738 308.357",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M505.773 320.009C505.884 311.007 504.752 310.621 504.752 310.621C497.572 304.325 471.671 300.929 471.671 300.929L461.455 300.238C451.542 300.735 452.867 305.126 452.867 305.126C452.867 305.126 453.972 300.238 471.174 304.435L481.502 307.141C481.502 307.141 492.215 310.538 491.608 320.147L491.497 351.46C491.497 351.46 491.138 384.844 486.638 387.633L479.651 391.83C479.651 391.83 458.5 399.727 449.802 394.619",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M466.01 300.516L479.375 303.608C479.375 303.608 488.57 305.9 491.828 310.594C491.828 310.594 494.148 312.886 494.148 320.204",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M491.304 310.125C491.304 310.125 493.734 309.021 504.752 310.622",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M449.857 394.592C449.857 394.592 449.388 398.098 455.407 398.568C455.407 398.568 465.127 400.363 482.744 393.597L487.438 390.367C487.438 390.367 490.31 388.765 491.111 384.734C491.111 384.734 492.464 378.908 492.464 376.257",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M479.126 379.709C479.126 379.709 480.535 380.013 480.535 382.995V391.251",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M488.46 389.567C488.46 389.567 496.412 390.865 502.211 389.816",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M457.312 398.817C457.312 398.817 470.953 400.005 486.389 396.332L496.909 393.571C496.909 393.571 503.233 391.804 503.233 386.806L504.033 377.279",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M512.234 357.728C511.682 370.679 509.776 373.357 509.776 373.357C508.23 377.168 504.558 377.14 504.558 377.14L494.396 377.085C492.712 377.03 491.414 375.538 491.524 373.688L493.264 348.726L493.181 345.606V322.798C493.181 321.141 494.562 319.788 496.246 319.788L506.435 319.982C506.435 319.982 510.108 320.037 511.461 323.571C511.461 323.571 513.753 326.83 512.897 343.508C512.897 343.508 512.289 355.85 512.234 357.7V357.728Z",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M491.58 373.413C491.58 373.413 495.004 373.192 496.992 364.66C496.992 364.66 498.207 360.463 498.649 352.676C498.704 351.572 499.146 343.592 499.091 342.653C498.897 336.882 498.152 331.552 498.152 331.552C496.688 322.661 493.237 323.075 493.237 323.075",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M849.057 71.7427C848.504 71.6047 846.406 71.3839 845.66 70.8316C844.915 70.3898 844.639 69.506 844.501 68.5396C844.363 67.5731 844.169 65.1432 844.142 64.7842C844.059 62.9342 844.252 60.9736 844.611 59.234C844.86 58.1019 845.522 56.9976 845.522 56.9976C845.522 56.9976 845.881 56.252 846.461 55.9759C849.25 55.4513 852.343 55.3958 855.27 55.3682L1152.33 58.9027C1150.01 61.4983 1147 64.3699 1144.4 66.7446C1142.89 68.1529 1140.9 70.2791 1139.05 71.2179C1135.24 72.9023 1130.79 73.1511 1126.7 73.5653L1107.57 73.7584L849.609 71.798L849.001 71.7427H849.057Z",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M1164.84 51.4206C972.9 46.8921 703.647 47.0577 507.623 48.6041C504.53 48.6041 494.728 48.5764 492.602 48.5488C453.861 47.9965 339.212 52.0556 292.215 50.9234",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M848.973 71.8272L814.292 71.5508",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M1152.08 92.8125H512.732V100.848H1152.08V92.8125Z",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M1156.8 78.565L1156.5 77.9576L1156.19 77.847L1150.31 77.6539L1140.95 77.3502L1131.48 77.129L1122.04 76.9359L1112.57 76.8253L1093.73 76.6322L1075.92 76.4387L814.292 74.5889",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M1201.34 249.24V250.151V250.262L1201.45 250.455L1201.75 250.566H1203.52H1204.96L1205.15 250.676L1205.37 250.759V251.284",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M1218.96 249.24V250.262V250.566L1219.04 250.759L1219.29 251.256",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M1190.54 114.736L1191.68 121.474L1193.22 130.917L1194.47 139.975L1195.68 149.308L1196.32 155.521L1196.92 161.816L1198.06 174.408L1198.58 181.449L1199.08 188.546L1199.82 202.076L1200.21 213.37L1200.43 221.295L1200.62 229.33L1200.84 240.706V248.521V248.742L1200.93 249.045L1201.04 249.239H1201.15H1220.89",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M1204.13 103.774L1204.24 103.968",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M1201.34 88.6709L1204.24 103.969",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M1214.93 249.238C1215.06 245.511 1213.55 208.123 1215.23 205.721C1215.29 201.302 1215.18 196.719 1215.04 192.301C1213.96 170.763 1212.08 148.506 1209.07 127.134C1208.3 121.694 1207.36 115.813 1206.2 110.456C1205.65 108.358 1205.37 105.817 1204.24 103.94L1204.13 103.746C1203.99 103.636 1203.69 103.47 1203.52 103.442C1201.73 105.044 1199.82 107.142 1198.08 108.827C1196.87 110.18 1194.96 111.671 1194.88 113.604",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M1189.94 111.505L1189.3 107.943V107.639L1189.11 103.553",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M1189.94 111.505L1190.54 114.735",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M1207.53 75.417C1212.03 85.2472 1214.46 97.2038 1215.87 108.111C1216 109.188 1216.09 110.154 1216.17 111.038C1218.99 147.321 1221.28 214.945 1220.89 249.24",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M1165.44 54.2656L1165.83 54.3482C1175.27 54.9557 1185.93 56.7506 1195.07 59.291L1197.23 59.7882L1201.12 58.1035",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M1193.11 55.0934C1185.02 52.7739 1172.79 51.697 1164.31 50.9238C1163.95 50.9238 1163.71 51.1724 1163.4 51.3381",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M1183.37 55.7567L1194.24 55.0664C1194.24 55.0664 1194.88 54.956 1195.18 56.0881L1195.82 59.2084L1183.45 56.0055C1183.45 56.0055 1183.2 55.8948 1183.37 55.7291V55.7567Z",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M1195.07 55.7832C1195.07 55.7832 1198.06 56.722 1198.25 56.8049C1198.25 56.8049 1200.54 57.4123 1201.12 58.1302L1201.67 58.655L1201.62 58.8206L1197.42 60.4776",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M1164.92 51.4473L1165.11 51.7786L1165.55 55.1749L1163.29 61.9952L1155.97 77.845",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M1197.25 59.8145L1197.45 60.4775L1197.75 62.5484",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M1196.45 61.8032L1182.9 82.8442C1182.9 82.8442 1180.27 86.5443 1181.13 92.8124L1183.03 101.98H1158.43L1156.75 91.7631L1154.73 91.3765C1155.72 79.9724 1156.88 78.2328 1156.88 78.2328L1164.34 62.3554L1166.55 55.4521L1171.77 55.977L1180.19 57.1641L1186.4 58.4895L1194.77 61.0853C1194.77 61.0853 1197.7 61.4165 1199.52 65.4756C1199.52 65.4756 1201.87 70.3079 1202.89 75.1401C1202.89 75.1401 1203 75.6923 1202.75 76.0512L1198.55 80.9388",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M1154.76 91.4053C1154.76 91.4053 1154.7 92.2061 1154.29 92.1509V93.6144",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M1152.14 93.6406H1154.54C1154.54 93.6406 1154.62 102.284 1153.96 103.609",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M1193.09 71.8555L1184.97 84.8334C1185.24 83.508 1181.24 82.0446 1178.26 81.1333C1176.57 80.6087 1174.83 80.2219 1173.09 79.9182L1168.65 79.145L1157.08 78.0684",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M1194.44 69.9216C1197.31 73.8426 1198.5 80.7736 1198.5 80.7736C1198.5 81.7953 1196.84 81.9055 1196.84 81.9055C1195.24 75.0023 1192.67 71.1367 1192.67 71.1367L1192.42 68.458C1192.42 68.458 1193.14 68.0715 1194.19 69.5903L1194.44 69.894V69.9216Z",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M1198.63 63.8193L1194.49 69.8664",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M1196.84 81.9048L1196.98 82.4296L1189.27 93.3365L1188.72 96.6227L1189.36 95.242L1190.3 93.9992L1197.72 83.4789L1203.05 77.2107C1203.05 77.2107 1203.5 76.8517 1203.63 77.7905L1204.16 79.7789L1206.42 79.1988C1206.42 79.1988 1208.11 78.8398 1207.83 77.1002C1206.34 67.9327 1202.83 60.7812 1202.83 60.7812L1201.95 58.9587L1201.67 58.6826",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M1196.9 84.6942C1196.9 84.6942 1197.36 84.5009 1197.5 85.0808L1198.58 89.278C1198.58 89.278 1198.72 89.9958 1198.94 89.8854L1200.13 88.3945C1200.13 88.3945 1200.26 88.1735 1200.07 87.5936L1198.94 82.7614C1198.94 82.7614 1198.94 82.4854 1198.52 82.5682",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M1207.06 78.8691L1206.73 81.1612C1206.73 81.1612 1206.5 81.8516 1205.65 82.9285L1193.89 98.5848C1193.89 98.5848 1192.62 99.579 1193.53 106.675",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M1190.82 93.3359L1194.96 113.908L1199.41 150.439L1203.25 183.023L1205.21 249.238",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M1186.46 82.4043L1188.11 85.0274",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M1189.08 87.042L1190.43 91.4876V91.6808",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M1188.75 96.623L1189.11 103.554",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M1189.11 103.553L1152.25 103.636",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M849.057 428.777C848.504 428.915 846.406 429.136 845.66 429.688C844.915 430.13 844.639 431.013 844.501 431.98C844.363 432.946 844.169 435.376 844.142 435.735C844.059 437.585 844.252 439.546 844.611 441.285C844.86 442.417 845.522 443.522 845.522 443.522C845.522 443.522 845.881 444.267 846.461 444.544C849.25 445.068 852.343 445.123 855.27 445.151L1152.33 441.616C1150.01 439.021 1147 436.149 1144.4 433.775C1142.89 432.366 1140.9 430.24 1139.05 429.301C1135.24 427.617 1130.79 427.368 1126.7 426.954L1107.57 426.761L849.609 428.721L849.001 428.777H849.057Z",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M1164.84 449.103C972.9 453.631 703.647 453.465 507.623 451.919C504.53 451.919 494.728 451.946 492.602 451.974C453.861 452.526 339.212 448.467 292.215 449.599",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M848.973 428.725L814.292 428.973",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M1152.08 399.674H512.732V407.709H1152.08V399.674Z",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M1156.8 421.959L1156.5 422.567L1156.19 422.677L1150.31 422.87L1140.95 423.174L1131.48 423.395L1122.04 423.588L1112.57 423.699L1093.73 423.892L1075.92 424.085L814.292 425.935",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M1190.54 385.784L1191.68 379.047L1193.22 369.603L1194.47 360.574L1195.68 351.213L1196.32 345L1196.92 338.704L1198.06 326.113L1198.58 319.072L1199.08 311.975L1199.82 298.445L1200.21 287.179L1200.43 279.226L1200.62 271.219L1200.84 259.815V252V251.779L1200.93 251.475L1201.04 251.282H1201.15H1220.89",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M1204.13 396.747L1204.24 396.554",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M1201.34 411.851L1204.24 396.554",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M1214.93 251.282C1215.06 255.01 1213.55 292.398 1215.23 294.8C1215.29 299.218 1215.18 303.802 1215.04 308.22C1213.96 329.758 1212.08 352.014 1209.07 373.386C1208.3 378.826 1207.36 384.708 1206.2 390.064C1205.65 392.163 1205.37 394.703 1204.24 396.581L1204.13 396.774C1203.99 396.885 1203.69 397.05 1203.52 397.078C1201.73 395.476 1199.82 393.378 1198.08 391.694C1196.87 390.341 1194.96 388.849 1194.88 386.917",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M1189.94 389.015L1189.3 392.576V392.881L1189.11 396.967",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M1189.94 389.015L1190.54 385.784",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M1207.53 425.105C1212.03 415.275 1214.46 403.319 1215.87 392.412C1216 391.335 1216.09 390.368 1216.17 389.484C1218.99 353.201 1221.28 285.577 1220.89 251.282",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M1165.44 446.257L1165.83 446.174C1175.27 445.567 1185.93 443.772 1195.07 441.231L1197.23 440.734L1201.12 442.419",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M1193.11 445.43C1185.02 447.749 1172.79 448.826 1164.31 449.599C1163.95 449.599 1163.71 449.351 1163.4 449.185",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M1183.37 444.766L1194.24 445.456C1194.24 445.456 1194.88 445.567 1195.18 444.435L1195.82 441.314L1183.45 444.518C1183.45 444.518 1183.2 444.628 1183.37 444.794V444.766Z",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M1195.07 444.739C1195.07 444.739 1198.06 443.8 1198.25 443.717C1198.25 443.717 1200.54 443.11 1201.12 442.392L1201.67 441.867L1201.62 441.702L1197.42 440.045",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M1164.92 449.101L1165.11 448.742L1165.55 445.346L1163.29 438.526L1155.97 422.676",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M1197.25 440.707L1197.45 440.045L1197.75 437.974",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M1196.45 438.719L1182.9 417.678C1182.9 417.678 1180.27 413.978 1181.13 407.71L1183.03 398.542H1158.43L1156.75 408.759L1154.73 409.145C1155.72 420.549 1156.88 422.289 1156.88 422.289L1164.34 438.166L1166.55 445.07L1171.77 444.545L1180.19 443.358L1186.4 442.032L1194.77 439.437C1194.77 439.437 1197.7 439.105 1199.52 435.046C1199.52 435.046 1201.87 430.214 1202.89 425.382C1202.89 425.382 1203 424.829 1202.75 424.471L1198.55 419.583",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M1154.76 409.118C1154.76 409.118 1154.7 408.318 1154.29 408.373V406.909",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M1152.14 406.881H1154.54C1154.54 406.881 1154.62 398.239 1153.96 396.913",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M1193.09 428.668L1184.97 415.689C1185.24 417.015 1181.24 418.479 1178.26 419.39C1176.57 419.914 1174.83 420.301 1173.09 420.605L1168.65 421.378L1157.08 422.455",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M1194.44 430.601C1197.31 426.68 1198.5 419.749 1198.5 419.749C1198.5 418.728 1196.84 418.617 1196.84 418.617C1195.24 425.52 1192.67 429.386 1192.67 429.386L1192.42 432.065C1192.42 432.065 1193.14 432.451 1194.19 430.932L1194.44 430.629V430.601Z",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M1198.63 436.703L1194.49 430.655",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M1196.84 418.617L1196.98 418.092L1189.27 407.185L1188.72 403.899L1189.36 405.28L1190.3 406.523L1197.72 417.043L1203.05 423.311C1203.05 423.311 1203.5 423.67 1203.63 422.731L1204.16 420.743L1206.42 421.323C1206.42 421.323 1208.11 421.682 1207.83 423.422C1206.34 432.589 1202.83 439.741 1202.83 439.741L1201.95 441.563L1201.67 441.839",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M1196.9 415.828C1196.9 415.828 1197.36 416.021 1197.5 415.441L1198.58 411.244C1198.58 411.244 1198.72 410.526 1198.94 410.637L1200.13 412.128C1200.13 412.128 1200.26 412.348 1200.07 412.928L1198.94 417.761C1198.94 417.761 1198.94 418.037 1198.52 417.954",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M1207.06 421.653L1206.73 419.361C1206.73 419.361 1206.5 418.671 1205.65 417.594L1193.89 401.937C1193.89 401.937 1192.62 400.943 1193.53 393.847",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M1190.82 407.184L1194.96 386.613L1199.41 350.081L1203.25 317.525L1205.21 251.282",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M1186.46 418.149L1188.11 415.498",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M1189.08 413.482L1190.43 409.036V408.843",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M1188.75 403.901L1189.11 396.97",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M1189.11 396.969L1152.25 396.886",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M128.223 448.078C131.868 449.128 142.333 449.707 142.333 449.707L142.443 449.597L143.879 449.707C148.325 450.094 153.129 450.619 157.575 450.84C172.265 451.806 187.204 452.579 201.921 452.883C217.882 453.38 234.118 453.601 250.078 453.601C256.843 453.656 264.106 453.297 270.871 453.104C273.522 452.883 278.05 451.392 280.452 450.646L280.949 455.865C280.204 455.948 279.486 456.114 278.768 456.362C278.299 456.5 277.443 456.804 277.001 457.273C276.642 457.687 276.697 457.991 276.697 457.991C277.028 462.547 278.381 468.677 279.486 473.123C279.873 474.697 280.259 476.298 280.701 477.872C281.087 479.281 281.502 480.661 281.943 482.042C282.33 483.174 282.689 484.389 283.297 485.411C285.533 489.276 288.736 495.324 291.636 498.527C291.636 498.527 292.243 499.328 293.375 499.438L295.336 499.548C295.943 499.548 300.113 495.738 300.472 495.103C300.693 494.716 300.748 494.302 300.472 493.86H300.582L301.3 494.275H301.411L304.945 492.673C304.945 492.673 304.973 492.673 305 492.7C305.773 492.397 305.442 491.458 305.525 490.823C303.813 482.677 300.085 469.34 298.042 461.139C298.042 461.084 298.014 461.001 297.987 460.946L297.02 458.102C296.937 457.826 296.772 457.604 296.523 457.439L294.369 455.865C294.176 455.727 293.983 455.616 293.762 455.534L292.354 455.009C291.884 453.325 291.718 451.806 291.967 450.453H293.099L378.257 450.259C423.294 451.143 516.294 452.027 516.294 452.027C595.184 452.634 685.312 452.993 777.208 452.938L814.651 453.076C814.651 453.076 1056.59 451.613 1157.57 449.321C1159.73 449.266 1163.37 449.265 1163.37 449.265C1163.7 449.404 1163.93 449.68 1164.28 449.68C1172.76 448.907 1184.99 447.83 1193.08 445.51H1194.22C1194.22 445.51 1194.71 445.593 1195.05 444.792C1195.05 444.792 1198.03 443.853 1198.22 443.771C1198.22 443.771 1200.51 443.163 1201.09 442.445L1201.64 441.92L1201.92 441.644L1202.8 439.822C1202.8 439.822 1205.92 433.443 1207.53 425.049C1212 415.219 1214.4 403.345 1215.84 392.466C1215.98 391.389 1216.06 390.422 1216.14 389.539C1218.9 353.863 1221.17 287.868 1220.89 253.049C1220.89 252.469 1220.89 247.388 1220.89 246.394C1221.11 211.298 1218.88 146.352 1216.14 111.063C1216.09 110.18 1215.98 109.213 1215.84 108.136C1214.43 97.2566 1212 85.3833 1207.53 75.5531C1205.92 67.1588 1202.8 60.7803 1202.8 60.7803L1201.92 58.9578L1201.64 58.6817L1201.09 58.1569C1200.51 57.439 1198.22 56.8316 1198.22 56.8316C1198.03 56.7487 1195.05 55.8099 1195.05 55.8099C1194.74 55.0091 1194.22 55.0919 1194.22 55.0919H1193.08C1184.99 52.7724 1172.76 51.6955 1164.28 50.9224C1163.93 50.9224 1163.68 51.1709 1163.37 51.3366C1163.37 51.3366 1159.73 51.3366 1157.57 51.2813C1056.59 48.9895 814.651 47.526 814.651 47.526L777.208 47.6642C685.312 47.609 595.156 47.9678 516.294 48.5753C516.294 48.5753 423.294 49.459 378.257 50.3426L293.099 50.1491H291.967C291.718 48.7961 291.856 47.2776 292.354 45.5933L293.762 45.0684C293.983 44.9856 294.176 44.8752 294.369 44.7371L296.523 43.1633C296.744 42.9976 296.91 42.7768 297.02 42.5006L297.987 39.6564C297.987 39.6564 298.042 39.5182 298.042 39.463C300.085 31.2619 303.813 17.9249 305.525 9.77913C305.47 9.14404 305.801 8.20539 305 7.90165C305 7.90165 304.973 7.90167 304.945 7.92929L301.411 6.32752H301.3L300.582 6.74178H300.472C300.748 6.29998 300.665 5.88592 300.472 5.49934C300.113 4.83663 295.971 1.05371 295.336 1.05371L293.375 1.16393C292.215 1.27438 291.636 2.07537 291.636 2.07537C288.736 5.27846 285.533 11.3257 283.297 15.1915C282.689 16.2408 282.33 17.428 281.943 18.5602C281.502 19.9408 281.087 21.3491 280.701 22.7297C280.259 24.3037 279.873 25.8775 279.486 27.4791C278.409 31.9523 277.028 38.0547 276.697 42.6109C276.697 42.6109 276.642 42.9146 277.001 43.3288C277.443 43.7982 278.299 44.1022 278.768 44.2403C279.458 44.4888 280.204 44.6543 280.949 44.7371L280.48 49.9836C278.05 49.2105 273.522 47.7193 270.871 47.4984C264.106 47.2775 256.843 46.9463 250.078 47.0015C234.118 47.0015 217.882 47.2225 201.921 47.7195C187.204 47.9956 172.265 48.7964 157.575 49.7628C153.129 49.9837 148.325 50.5081 143.879 50.8947L142.443 51.0053L142.333 50.8947C142.333 50.8947 131.868 51.4748 128.223 52.5241M128.526 52.4136C124.688 52.7449 120.74 53.5734 117.012 54.5398C112.898 56.1966 106.022 58.875 101.99 60.7527L101.383 60.8629L86.2511 63.0997C70.4842 64.9774 53.9993 69.0642 42.0982 80.0817C35.0293 86.7916 29.562 95.3791 25.3372 104.077C18.931 116.558 13.298 130.227 10.012 143.812C10.012 143.812 9.48739 144.199 8.79707 146.546C6.83656 152.455 6.44999 164.439 5.8149 170.541C5.04174 181.034 3.99245 192.355 3.13645 202.876C1.39684 217.87 0.872193 233.94 1.06548 250.342C0.872193 266.772 1.42445 282.843 3.13645 297.809C3.99245 308.33 5.04174 319.623 5.8149 330.144C6.44999 336.246 6.86417 348.23 8.79707 354.139C9.515 356.514 10.012 356.873 10.012 356.873C13.3256 370.458 18.9586 384.155 25.3372 396.608C29.562 405.306 35.0569 413.893 42.0982 420.603C53.9993 431.621 70.4566 435.68 86.2511 437.585L101.383 439.822L101.99 439.932C106.022 441.782 112.898 444.461 117.012 446.145C120.74 447.139 124.688 447.968 128.526 448.271",
    stroke: "#26231E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M489.62 49.1855V92.8416",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M337.473 80.3879V50.7041",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M809.873 107.806H667.805V190.727H809.873V107.806Z",
    stroke: "#1B1B19",
    strokeWidth: 0.54,
    strokeMiterlimit: 10
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M809.873 107.806H667.805V190.727H809.873V107.806Z",
    fill: "#338CFF",
    fillOpacity: 0.13
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M810.426 100.571V397.962H1145.98V100.571H810.426Z",
    stroke: "#1B1B19",
    strokeWidth: 0.54,
    strokeMiterlimit: 10
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M810.426 100.571V397.962H1145.98V100.571H810.426Z",
    fill: "#E5E5E5"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M689.565 117.028H776.518C787.729 117.028 796.841 126.141 796.841 137.351V172.613C796.841 177.445 792.92 181.366 788.087 181.366H689.565C684.733 181.366 680.812 177.445 680.812 172.613V125.781C680.812 120.949 684.733 117.028 689.565 117.028Z",
    fill: "white",
    stroke: "#A6A7AA",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M804.6 110.43H674.074C672.625 110.43 671.45 111.604 671.45 113.053V184.349C671.45 185.798 672.625 186.972 674.074 186.972H804.6C806.048 186.972 807.223 185.798 807.223 184.349V113.053C807.223 111.604 806.048 110.43 804.6 110.43Z",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M738.826 147.734C741.815 147.734 744.238 145.237 744.238 142.156C744.238 139.075 741.815 136.578 738.826 136.578C735.837 136.578 733.414 139.075 733.414 142.156C733.414 145.237 735.837 147.734 738.826 147.734Z",
    fill: "white",
    stroke: "#A6A7AA",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M738.826 146.933C741.373 146.933 743.437 144.794 743.437 142.156C743.437 139.518 741.373 137.379 738.826 137.379C736.279 137.379 734.214 139.518 734.214 142.156C734.214 144.794 736.279 146.933 738.826 146.933Z",
    fill: "white",
    stroke: "#A6A7AA",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M760.088 143.427L757.796 141.163C757.299 140.666 757.299 139.865 757.796 139.368L785.906 111.59C786.403 111.093 787.231 111.093 787.728 111.59L790.02 113.854C790.517 114.351 790.517 115.152 790.02 115.649L761.91 143.427C761.413 143.924 760.585 143.924 760.088 143.427Z",
    fill: "white",
    stroke: "#A6A7AA",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M785.74 118.962C788.531 118.962 790.793 116.922 790.793 114.405C790.793 111.889 788.531 109.85 785.74 109.85C782.949 109.85 780.687 111.889 780.687 114.405C780.687 116.922 782.949 118.962 785.74 118.962Z",
    fill: "white",
    stroke: "#A6A7AA",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M782.316 111.093C782.316 111.093 780.88 112.17 773.149 114.434C769.586 117.913 774.723 119.266 774.723 119.266C774.723 119.266 780.687 118.3 785.74 118.99",
    fill: "white"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M782.316 111.093C782.316 111.093 780.88 112.17 773.149 114.434C769.586 117.913 774.723 119.266 774.723 119.266C774.723 119.266 780.687 118.3 785.74 118.99",
    stroke: "#A6A7AA",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1069.32 99.9375H659.412V155.08H1069.32V99.9375Z",
    fill: "#338CFF",
    fillOpacity: 0.13
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M632.709 399.675V318.079H532.862V399.675H632.709Z",
    fill: "#E5E5E5"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M632.709 399.675V318.079H532.862V399.675H632.709Z",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M632.709 318.079V313.716H532.861V318.079H632.709Z",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M530.073 315.316L477.277 263.155C473.466 259.4 473.466 253.298 477.277 249.515L509.225 217.953C513.036 214.198 519.221 214.198 523.031 217.953L575.827 270.114C579.638 273.869 579.638 279.972 575.827 283.755L543.879 315.316C540.068 319.072 533.883 319.072 530.073 315.316Z",
    fill: "#E5E5E5"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M530.073 315.316L477.277 263.155C473.466 259.4 473.466 253.298 477.277 249.515L509.225 217.953C513.036 214.198 519.221 214.198 523.031 217.953L575.827 270.114C579.638 273.869 579.638 279.972 575.827 283.755L543.879 315.316C540.068 319.072 533.883 319.072 530.073 315.316Z",
    stroke: "#1B1B19",
    strokeWidth: 0.54,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M632.71 353.259H532.862V399.317H632.71V353.259Z",
    stroke: "#1B1B19",
    strokeWidth: 0.54,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M632.71 353.259H532.862V399.317H632.71V353.259Z",
    fill: "#338CFF",
    fillOpacity: 0.13
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M1069.32 99.9375H659.412V155.08H1069.32V99.9375Z",
    stroke: "#006CFA",
    strokeOpacity: 0.76,
    strokeMiterlimit: 10
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1069.3 399.038H810.067L810.233 343.923H1069.3V399.038Z",
    fill: "#338CFF",
    fillOpacity: 0.13
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M1069.3 343.923H810.233V399.066H1069.3V343.923Z",
    stroke: "#006CFA",
    strokeOpacity: 0.76,
    strokeMiterlimit: 10
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M539.847 108.251L540.289 108.693L540.372 108.776C546.253 115.265 551.141 119.158 559.066 122.14C559.646 122.361 560.916 122.665 560.916 122.665C563.456 123.576 566.604 124.211 569.31 124.543C581.543 125.205 606.449 126.034 618.516 126.475",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M541.642 107.45C544.321 110.294 547.165 113.553 550.478 115.707C550.617 115.79 550.727 115.9 550.727 115.9C557.188 120.152 564.892 122.693 572.652 122.996C572.845 122.996 573.121 123.024 573.204 123.024C586.596 123.493 601.148 123.963 614.54 124.515",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M544.735 110.707C545.259 110.265 548.021 109.465 548.518 109.465C550.174 109.133 554.372 108.94 554.372 108.94C563.677 108.664 573.369 110.293 582.481 112.143C586.596 113.027 591.317 114.462 595.459 115.18C598.304 115.457 601.231 115.981 604.075 116.064C604.24 116.064 604.378 116.064 604.378 116.064C605.731 116.147 607.167 116.174 608.52 116.147",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M542.995 111.535C539.903 113.137 538.329 115.704 537.666 116.781C535.844 119.57 534.353 130.836 533.607 134.15L532.337 144.753L531.785 150.083L531.426 155.329C531.15 161.293 531.067 164.828 532.751 175.818C534.27 180.65 536.148 184.433 540.952 186.421",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M607.609 113.331C605.097 113.248 602.529 112.834 600.043 112.53C589.827 110.459 577.87 107.118 567.516 105.848C560.999 105.268 552.964 105.158 546.419 106.041C546.281 106.041 544.321 106.538 543.548 106.814C542.056 107.339 540.344 107.947 539.129 108.692C537.694 109.548 535.788 111.288 535.788 111.288C531.895 114.933 531.094 121.145 530.211 126.143L528.94 132.909L527.863 139.674C527.587 141.938 526.897 147.737 526.704 149.918L526.345 156.766C526.29 165.243 527.394 174.19 530.763 182.059C532.061 184.959 534.214 187.555 537.059 189.101C537.059 189.101 537.694 189.46 538.412 189.846C538.605 189.957 538.798 190.04 538.991 190.095C540.317 190.592 541.725 191.144 543.161 191.531C550.561 193.326 561.965 193.712 570.801 192.746C580.162 191.917 591.18 189.349 600.651 188.88L602.418 188.825H605.815",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M606.974 186.31C602.28 185.702 597.835 185.896 593.14 186.172C586.872 186.752 580.08 188.353 573.701 188.905C573.701 188.905 572.375 189.044 571.851 189.099C565.472 189.706 558.79 189.872 552.494 189.403C549.264 189.016 545.895 188.823 542.94 187.442",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M633.759 115.54C633.593 116.562 633.123 120.925 632.93 122.029C632.682 123.217 632.571 123.631 632.074 124.128C631.632 124.57 631.025 124.846 630.39 124.929C626.22 125.536 621.029 125.564 616.887 125.702C615.285 125.619 614.126 124.156 613.187 123.217C610.508 120.29 608.52 117.059 607.609 113.331",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M631.025 189.184C630.859 188.162 630.39 183.799 630.197 182.695C629.948 181.507 629.838 181.094 629.341 180.597C628.899 180.155 628.291 179.879 627.656 179.796C623.487 179.188 618.295 179.161 614.153 179.022C612.552 179.105 611.392 180.569 610.453 181.508C607.775 184.435 605.787 187.665 604.875 191.393",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M632.489 126.311L631.936 152.515L630.694 178.609",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M630.694 178.609C630.197 178.36 617.605 177.338 616.722 177.283",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M619.51 125.7L618.516 126.501",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M616.639 179.188L617.633 152.762L618.516 126.502",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M557.133 176.536L558.044 151.795L558.127 149.31L559.121 122.139",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M597.42 175.846L598.331 150.802L599.325 125.784",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M616.722 176.535C602.86 176.259 578.975 174.713 565.03 174.961C561.827 175.376 559.894 175.735 556.498 176.618C555.117 177.143 553.626 177.53 552.273 178.137C551.39 178.717 550.395 179.214 549.484 179.738C545.48 182.527 541.145 185.868 538.025 189.624",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M539.737 190.342C547.689 183.108 549.346 179.905 560.474 177.53C563.097 177.033 565.72 176.619 568.399 176.563C582.647 177.033 598.386 177.751 612.662 178.165L614.374 178.248L616.666 178.331",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M618.516 127.635L621.167 127.497C621.167 127.497 632.35 126.668 632.461 126.337C632.461 126.337 634.283 124.984 634.587 116.12",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M653.888 126.31C653.971 118.44 653.005 118.081 653.005 118.081C646.709 112.559 624.011 109.576 624.011 109.576L615.065 108.969C606.367 109.411 607.526 113.249 607.526 113.249C607.526 113.249 608.493 108.969 623.569 112.641L632.599 115.016C632.599 115.016 641.987 117.998 641.463 126.393L641.38 153.812C641.38 153.812 641.048 183.054 637.127 185.512L631.025 189.184C631.025 189.184 612.497 196.115 604.875 191.642",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M619.069 109.217L630.777 111.923C630.777 111.923 638.84 113.939 641.684 118.053C641.684 118.053 643.727 120.069 643.727 126.447",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M641.214 117.638C641.214 117.638 643.34 116.671 653.005 118.08",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M604.903 191.641C604.903 191.641 604.489 194.706 609.763 195.12C609.763 195.12 618.268 196.694 633.704 190.785L637.818 187.941C637.818 187.941 640.331 186.533 641.049 183.026C641.049 183.026 642.236 177.917 642.236 175.598",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M630.556 178.607C630.556 178.607 631.798 178.884 631.798 181.507V188.741",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M638.729 187.223C638.729 187.223 645.715 188.355 650.768 187.444",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M611.448 195.342C611.448 195.342 623.404 196.391 636.907 193.161L646.102 190.731C646.102 190.731 651.624 189.184 651.624 184.794L652.315 176.455",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M659.577 159.335C659.107 170.683 657.423 173.03 657.423 173.03C656.07 176.372 652.867 176.344 652.867 176.344H643.976C642.512 176.261 641.38 174.936 641.463 173.334L643.009 151.493L642.926 148.759V128.767C642.926 127.304 644.114 126.116 645.605 126.116L654.524 126.282C654.524 126.282 657.727 126.337 658.914 129.43C658.914 129.43 660.93 132.274 660.184 146.909C660.184 146.909 659.66 157.733 659.604 159.335H659.577Z",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M641.463 173.086C641.463 173.086 644.473 172.893 646.185 165.409C646.185 165.409 647.261 161.737 647.648 154.916C647.703 153.95 648.062 146.936 648.035 146.135C647.869 141.082 647.206 136.416 647.206 136.416C645.936 128.629 642.899 128.988 642.899 128.988",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M810.067 283.369H632.709V399.757H810.067V283.369Z",
    stroke: "#1B1B19",
    strokeWidth: 0.54,
    strokeMiterlimit: 10
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M810.067 283.369H632.709V399.757H810.067V283.369Z",
    fill: "#338CFF",
    fillOpacity: 0.13
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M804.406 287.565H638.094V396.774H804.406V287.565Z",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M781.57 381.837H659.3C658.934 381.837 658.638 382.134 658.638 382.5V383.963C658.638 384.329 658.934 384.626 659.3 384.626H781.57C781.936 384.626 782.233 384.329 782.233 383.963V382.5C782.233 382.134 781.936 381.837 781.57 381.837Z",
    stroke: "#A6A7AA",
    strokeWidth: 0.13,
    strokeMiterlimit: 10
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M781.57 373.664H659.3C658.934 373.664 658.638 373.961 658.638 374.327V375.79C658.638 376.156 658.934 376.453 659.3 376.453H781.57C781.936 376.453 782.233 376.156 782.233 375.79V374.327C782.233 373.961 781.936 373.664 781.57 373.664Z",
    stroke: "#A6A7AA",
    strokeWidth: 0.13,
    strokeMiterlimit: 10
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M781.57 365.49H659.3C658.934 365.49 658.638 365.787 658.638 366.153V367.616C658.638 367.982 658.934 368.279 659.3 368.279H781.57C781.936 368.279 782.233 367.982 782.233 367.616V366.153C782.233 365.787 781.936 365.49 781.57 365.49Z",
    stroke: "#A6A7AA",
    strokeWidth: 0.13,
    strokeMiterlimit: 10
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M781.57 357.317H659.3C658.934 357.317 658.638 357.614 658.638 357.98V359.443C658.638 359.809 658.934 360.106 659.3 360.106H781.57C781.936 360.106 782.233 359.809 782.233 359.443V357.98C782.233 357.614 781.936 357.317 781.57 357.317Z",
    stroke: "#A6A7AA",
    strokeWidth: 0.13,
    strokeMiterlimit: 10
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M781.57 349.144H659.3C658.934 349.144 658.638 349.44 658.638 349.806V351.27C658.638 351.636 658.934 351.932 659.3 351.932H781.57C781.936 351.932 782.233 351.636 782.233 351.27V349.806C782.233 349.44 781.936 349.144 781.57 349.144Z",
    stroke: "#A6A7AA",
    strokeWidth: 0.13,
    strokeMiterlimit: 10
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M781.57 340.971H659.3C658.934 340.971 658.638 341.267 658.638 341.633V343.097C658.638 343.463 658.934 343.76 659.3 343.76H781.57C781.936 343.76 782.233 343.463 782.233 343.097V341.633C782.233 341.267 781.936 340.971 781.57 340.971Z",
    stroke: "#A6A7AA",
    strokeWidth: 0.13,
    strokeMiterlimit: 10
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M781.57 332.768H659.3C658.934 332.768 658.638 333.064 658.638 333.43V334.894C658.638 335.26 658.934 335.557 659.3 335.557H781.57C781.936 335.557 782.233 335.26 782.233 334.894V333.43C782.233 333.064 781.936 332.768 781.57 332.768Z",
    stroke: "#A6A7AA",
    strokeWidth: 0.13,
    strokeMiterlimit: 10
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M781.57 324.595H659.3C658.934 324.595 658.638 324.891 658.638 325.257V326.721C658.638 327.087 658.934 327.384 659.3 327.384H781.57C781.936 327.384 782.233 327.087 782.233 326.721V325.257C782.233 324.891 781.936 324.595 781.57 324.595Z",
    stroke: "#A6A7AA",
    strokeWidth: 0.13,
    strokeMiterlimit: 10
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M781.57 316.421H659.3C658.934 316.421 658.638 316.718 658.638 317.084V318.547C658.638 318.913 658.934 319.21 659.3 319.21H781.57C781.936 319.21 782.233 318.913 782.233 318.547V317.084C782.233 316.718 781.936 316.421 781.57 316.421Z",
    stroke: "#A6A7AA",
    strokeWidth: 0.13,
    strokeMiterlimit: 10
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M781.57 308.248H659.3C658.934 308.248 658.638 308.545 658.638 308.911V310.374C658.638 310.74 658.934 311.037 659.3 311.037H781.57C781.936 311.037 782.233 310.74 782.233 310.374V308.911C782.233 308.545 781.936 308.248 781.57 308.248Z",
    stroke: "#A6A7AA",
    strokeWidth: 0.13,
    strokeMiterlimit: 10
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M781.57 300.074H659.3C658.934 300.074 658.638 300.371 658.638 300.737V302.2C658.638 302.566 658.934 302.863 659.3 302.863H781.57C781.936 302.863 782.233 302.566 782.233 302.2V300.737C782.233 300.371 781.936 300.074 781.57 300.074Z",
    stroke: "#A6A7AA",
    strokeWidth: 0.13,
    strokeMiterlimit: 10
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M783.779 292.232H659.936C653.653 292.232 648.559 297.326 648.559 303.609V380.814C648.559 387.097 653.653 392.191 659.936 392.191H783.779C790.063 392.191 795.156 387.097 795.156 380.814V303.609C795.156 297.326 790.063 292.232 783.779 292.232Z",
    stroke: "#1B1B19",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarRedmax);
export default __webpack_public_path__ + "static/media/car_redmax.8d2b51f372f5d2c5c81dd6d3300a4321.svg";
export { ForwardRef as ReactComponent };